<template>
    <main v-if="data && data.page">
        <article>
            <h1 class="helvetica title1">Privacy Policy</h1>

            <div class="columns">
                <div class="bodyCont">
                    <BlockBody :body="data?.page.privacy_policy" />
                </div>
            </div>
        </article>
        <WebsiteFooter />
    </main>
</template>

<script lang="ts" setup>
const { getPrivacyPolicyPage } = usePages();
const { data } = useAsyncData('privacy-policy', () => getPrivacyPolicyPage());

</script>

<style lang="scss" scoped>
main {
    article {
        padding: var(--size-padding-header) 0 var(--size-gutter-sections) 0;
        margin: 0 var(--size-margin-page);



        h1 {
            margin-bottom: var(--size-gutter-double);
        }

        .columns {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);

            .bodyCont,
            .downloads,
            .tags {
                grid-column: 2;
            }
        }
    }
}


@media screen and (max-width: 1280px) {
    main article {

        .columns {
            display: flex;
            flex-direction: column;
            gap: var(--size-gutter-double);
        }
    }
}
</style>